import type { ReportsQuery } from "@gioia365/contracts";
import type { TabKey } from "../session/tab-context";

// Le chiavi di cache del Report (piano M7, Task 3; D7), in un modulo senza altre dipendenze, come quelle di «Conversazioni»: ogni
// lettura sta sotto la scheda, con la vista («Guarda come…», `null` fuori dalla vista) e la query: «Commerciali» (Task 3), «Campagne»
// (Task 5) e la giornata a blocchi (Task 7), che si rileggono insieme dal prefisso `all`.

export const reportKeys = {
  /** Tutto ciò che la scheda ha letto dei Report: il prefisso delle altre chiavi. */
  all: (tab: TabKey) => ["scheda", tab, "reports"] as const,
  /** «Commerciali» per periodo e «Di chi», in una vista. */
  sales: (tab: TabKey, view: string | null, query: ReportsQuery) => ["scheda", tab, "reports", "sales", view, query] as const,
  /** «Campagne» per periodo e «Di chi», in una vista (Task 5). */
  campaigns: (tab: TabKey, view: string | null, query: ReportsQuery) => ["scheda", tab, "reports", "campaigns", view, query] as const,
  /** La giornata a blocchi di 30 minuti di una persona in un giorno (`AAAA-MM-GG`), in una vista (Task 7). */
  workBlocks: (tab: TabKey, view: string | null, person: string, day: string) => ["scheda", tab, "reports", "work-blocks", view, person, day] as const,
};
